import { ProjectGet, Ulid } from "@kase/my-marathon-communication";
import { computed } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { Project } from "./interfaces";

const PROJECT_INACTIVE = 9;

export const PROJECT_BLOCKED_STATUS = 8;
export const PROJECT_NON_STANDARD = 4;
export const PROJECT_EXTERNAL = 0;
export const PROJECT_INTERNAL = 1;
export const FEECODE_NON_STANDARD = 900;
export const LOB_NON_STANDARD = 90;

export const makeProject = ({ connection, company }: ApiSliceParams) => {
    const {
        items: fullProjectsList,
        loading: getLoading,
        loaded: getLoaded,
        listen: startListen,
        get,
        getOrLoad: baseGetOrLoad,
    } = createListController<ProjectGet, Project, { active: boolean }>({
        name: "project",
        connection,
        view: (item) => ({
            ...item,
            id: item.id.toString(),
            _id: item.id,
            active: item.status !== PROJECT_INACTIVE,
            time_code_list_id: item.time_code_list_id?.equals(Ulid.ZERO)
                ? undefined
                : item.time_code_list_id,
        }),
        load: (con, id) =>
            con.project.get({
                id: Array.isArray(id) ? id : [id],
                company: company.value,
            }),
        list: (con, { active }) =>
            con.project.items({ company: company.value, groups: [], active }),
        getKey: ({ active }) => (active ? "1" : "0"),
    });
    const allProjects = computed(() =>
        fullProjectsList.value.filter(
            (p) => p.status !== PROJECT_BLOCKED_STATUS,
        ),
    );
    const projects = computed(() => allProjects.value.filter((p) => p.active));
    const loading = getLoading({ active: true });
    const loaded = getLoaded({ active: true });
    const inactiveLoading = getLoading({ active: false });

    const lookup = (query: string | null | undefined) => {
        if (!query) {
            return null;
        }

        const byId = allProjects.value.find((project) => project.id === query);

        if (byId) {
            return byId;
        }

        const finalQuery = query.toUpperCase().replace(/-|\b0+/g, "");

        return allProjects.value.find(
            (p) => `${p.client}${p.project}` === finalQuery,
        );
    };

    const listen = () => startListen({ active: true });

    const listenInactive = () => startListen({ active: false });

    const getOrLoad = (id: string | Readonly<Ulid>) =>
        baseGetOrLoad(id, { active: true });

    return {
        projects,
        allProjects,
        loading,
        loaded,
        inactiveLoading,
        lookup,
        get,
        getOrLoad,

        listen,
        listenInactive,
    };
};
